import Vue from 'vue';
import { AxiosPromise } from 'axios';
import {
  Response,
  TotalRemain,
} from '@/models';

class VehicleService extends Vue {
  private ROOT_API = process.env.VUE_APP_ROOT_API + '/webapi/vehicle';

  public getTotalPickupSetRemain(startDate: string, endDate: string): AxiosPromise<Response<TotalRemain[]>> {
    return Vue.axios.get<Response<TotalRemain[]>>(this.ROOT_API + '/get-total-pickup-remain', {
      params: {
        start: startDate,
        end: endDate,
      },
    });
  }

  public getTotalDeliverySetRemain(startDate: string, endDate: string): AxiosPromise<Response<TotalRemain[]>> {
    return Vue.axios.get<Response<TotalRemain[]>>(this.ROOT_API + '/get-total-delivery-remain', {
      params: {
        start: startDate,
        end: endDate,
      },
    });
  }

  // get all public holiday of japan
  public getAllHoliday(): AxiosPromise<Response<Date[]>> {
    return Vue.axios.get<Response<Date[]>>(this.ROOT_API + '/get-all-holiday');
  }

}
export const vehicleService = new VehicleService();
